<template>
  <div class="home" key="home">
    <Carousel />
    <div class="mipcom">
      <div>
        <strong>mipcom 2020</strong>
        <div style="text-align:center;">LineUp</div>
      </div>
      <a
        href="https://www.betafilm.com/en/search/do/market.html?id=8780"
        target="blank"
        class="play"
      ></a>
    </div>
    <a href="https://betafilm.com" target="_blank" class="logo"></a>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Carousel from "@/components/Carousel.vue";

export default defineComponent({
  name: "Home",
  components: {
    Carousel,
  },
});
</script>

<style scoped>
@keyframes homeIntro {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes homeOutro {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes miptvIntro {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0px);
  }
}
@keyframes miptvOutro {
  0% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(-100%);
  }
}
.play {
  width: 3.5vh;
  height: 3.5vh;
  margin-top: 0.6vh;
  transition: transform 0.3s linear;
  cursor: pointer;
  background: url("/img/play.png") center center no-repeat;
  background-size: contain;
}
.play:hover {
  transform: scale(1.1);
}
.logo {
  top: 5vh;
  width: 16.59vh;
  height: 5vh;
  background: url("/img/logo_beta.svg") center center no-repeat;
  background-size: contain;
  position: absolute;
}
.mipcom {
  top: 0px;
  width: 16.24vh;
  max-width: 16.24vh;
  height: 14vh;
  max-height: 14vh;
  left: calc(50% + 27vh);
  background: url("/img/mipcom.png") center center no-repeat;
  background-size: contain;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-transform: uppercase;
  padding: 2.3vh 0;
  font-size: 1.85vh;
  color: #fff;

  animation-name: miptvIntro;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  animation-duration: 1s;
}
@media (orientation: portrait) {
  .logo{
    max-width: 30vw;
  }
  .mipcom {
    /* display: none; */
    left: auto;
    right: 0;
    width: 30vw;
    height: calc(30vw * 0.844);
    font-size: min(3.2vw, 1.85vh);
  }
}
.home {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 1s linear;
  opacity: 1;

  animation-name: homeIntro;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  animation-duration: 2s;
}
.fade-leave-active.home {
  animation-name: homeOutro;
}
.fade-leave-active .miptv {
  animation-name: miptvOutro;
}
</style>
